import { createAction } from 'reflux';

const showStructures = createAction();

export default showStructures;



/** WEBPACK FOOTER **
 ** ./app/scripts/actions/showstructures.es6
 **/